
export function Footer(){
    return (
        <footer>
                    <div className="row copyright">
                        <div className="container">
                            <p>Faculdade de Engenharia Agrícola – FEAGRI, Av. Cândido Rondon, 501 - Barão Geraldo 13083-875 -
                                Campinas/SP. © 2015. Todos os direitos reservados.</p>
                        </div>
                    </div>
        </footer>
    )    
}